// visa-clients.service.ts
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

// اختياري: عرّف انترفيس
// export interface VisaClient {
//   id?: number;
//   name: string;
//   job?: string;
//   phone?: string;
//   paid?: number;
//   remaining?: number;
//   representative?: string;
//   representative_account?: string;
//   notes?: string;
//   type: 0 | 1;
//   created_at?: string;
//   updated_at?: string;
// }

@Injectable({ providedIn: 'root' })
export class VisaClientsService {
  private base = `${environment.Server_URL}/visa-clients`;

  constructor(private http: HttpClient) {}

  // GET /visa-clients?per_page=&page=
  getAll(perPage = 10, page = 1): Observable<any> {
    return this.http.get<any>(`${this.base}?per_page=${perPage}&page=${page}`);
  }

  // GET /visa-clients/{id}
  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.base}/${id}`);
  }

  // POST /visa-clients
  create(payload: any /* | VisaClient */): Observable<any> {
    return this.http.post<any>(this.base, payload);
  }


update(id: number, payload: FormData | any): Observable<any> {
  const isFormData = payload instanceof FormData;

  if (isFormData) {
    payload.append('_method', 'PUT'); // ✨ ده يخلي Laravel يفهم إن الريكوست update
    return this.http.post(`${this.base}/${id}`, payload);
  }

  return this.http.put(
    `${this.base}/${id}`,
    payload,
    { headers: { 'Content-Type': 'application/json' } }
  );
}


  // DELETE /visa-clients/{id}
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.base}/${id}`);
  }

  // GET /visa-clients/search?q=&type=&page=&per_page=
  // q: بحث عام (name, job, phone) — type: 0 أو 1
  search(q = '', type?: 0 | 1, page = 1, perPage = 10): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);

    if (q) params = params.set('q', q);

    return this.http.get<any>(`${this.base}/search`, { params });
  }
    filterByType(type: 0 | 1, page = 1, perPage = 10): Observable<any> {
    const params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);

    return this.http.get<any>(`${this.base}/type/${type}`, { params });
  }
}
